<template>
  <div class="header text-black sport">
    <b-row>
      <b-col cols="6" lg="2">
        <a @click="hideMenuAfterClick"><router-link :to="{ name: 'Home'}"><img class="logo" src="../../public/logo-endurobiking.png" width="120px"></router-link></a>
        <br>
        <i><span class="small">Geolocated MTB racing</span></i>
      </b-col>
      <b-col cols="0" lg="8" class="d-none d-sm-none d-md-none d-lg-block">
        <div class="margin-top">
          <div class="center-align">
            <router-link class="text-black margin" :to="{ name: 'Home'}">Explore</router-link>
            <span v-if="user && user.id">
              <router-link class="text-black margin" :to="{ name: 'Rider', params: { id: this.user.id }}">Profile</router-link>
            </span>
            <router-link class="text-black margin" :to="{ name: 'Clubs'}">Clubs</router-link>
            <router-link class="text-black margin" :to="{ name: 'Leaderboard'}">Leaderboard</router-link>
            <router-link class="text-black margin" :to="{ name: 'CreateRace'}">Create race</router-link>
            <span v-if="!alreadyRunsAsPWA" class="text-black margin">
              <a class="text-black" @click="showPWAInstall">Install App</a>
            </span>
          </div>
        </div>
      </b-col>
      <b-col cols="2" lg="0" class="d-md-block d-lg-none d-xl-none">
      </b-col>
      <b-col cols="0" lg="2" class="d-none d-sm-none d-md-none d-lg-block">
        <div v-if="user && user.email" class="right-align">
          <router-link class="text-black" :to="{ name: 'Account'}">
            {{ user.stravaDetails.firstname }} {{ user.stravaDetails.lastname }}
            <img class="margin-left" v-if="user.stravaDetails.profile" :src="user.stravaDetails.profile" width="50px">
            <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
          </router-link>
          <a class="text-black margin-left-2"><fa-icon icon="sign-out-alt" @click="signOut" title="Sign out" /></a>
        </div>
        <div v-else class="margin-top">
          <div class="right-align">
            <router-link class="text-black margin margin-top" :to="{ name: 'LogIn'}">Log In</router-link>
            <router-link class="text-black margin" :to="{ name: 'SignUp'}">Create an account</router-link>
          </div>
        </div>
      </b-col>
      <b-col cols="4" lg="0" class="d-md-block d-lg-none d-xl-none">
        <div v-if="!mobileMenuDisplayed" class="right-align">
          <a class="text-black"><fa-icon class="fa-3x" icon="bars" @click="displayMenu" title="Menu" /></a>
        </div>
        <div v-else class="right-align">
          <a class="text-black"><fa-icon class="fa-3x" icon="times" @click="displayMenu" title="Menu" /></a>
        </div>
      </b-col>
    </b-row>
    <div id="menu" class="header">
      <b-row cols="3" cols-sm="3" cols-md="3" cols-lg="3" cols-xl="3">
        <b-col>
        </b-col>
        <b-col>
          <div>
            <div class="center-align bigger-font-x2">
              <div v-if="!alreadyRunsAsPWA" class="center-align">
                <a class="text-black" @click="showPWAInstall">Install App</a>
              </div>
              <br>
              <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Home'}">Explore</router-link></a>
              <br>
              <br>
              <span v-if="user && user.id">
                <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Rider', params: { id: this.user.id }}">Profile</router-link></a>
                <br>
                <br>
              </span>
              <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Clubs'}">Clubs</router-link></a>
              <br>
              <br>
              <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Leaderboard'}">Leaderboard</router-link></a>
              <br>
              <br>
              <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'CreateRace'}">Create race</router-link></a>
              <br>
              <br>
              <div v-if="user && user.email">
                <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Account'}">
                  {{ user.stravaDetails.firstname }} {{ user.stravaDetails.lastname }}
                  <br>
                  <br>
                  <img class="margin-left" v-if="user.stravaDetails.profile" :src="user.stravaDetails.profile" width="50px">
                  <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
                </router-link></a>
                <br>
                <br>
                <a class="text-black margin-left-2"><fa-icon icon="sign-out-alt" @click="signOut" title="Sign out" /></a>
              </div>
              <div v-else>
                <div>
                  <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'LogIn'}">Log In</router-link></a>
                  <br>
                  <br>
                  <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'SignUp'}">Create an account</router-link></a>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import { onLogout } from '../vue-apollo';

  export default {
    name: 'Header',
    components: {  },
    data() {
      return {
        mobileMenuDisplayed: false
      }
    },
    mounted() {
      const menu = document.getElementById("menu");
      menu.style.display = "none";
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      alreadyRunsAsPWA() {
        return window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches
      }
    },
    methods: {
      async signOut() {
        await onLogout.apply(this, [this.$apollo.provider.defaultClient])
        if (this.$router.currentRoute.name !== 'Home') this.$router.push({ name: 'Home' });
        this.$router.go(0); // refresh the current page
      },
      displayMenu() {
        const menu = document.getElementById("menu");
        if (menu.style.display === "none") {
          menu.style.display = "block";
          this.mobileMenuDisplayed = true
        } else {
          menu.style.display = "none";
          this.mobileMenuDisplayed = false
        }
      },
      hideMenuAfterClick() {
        const menu = document.getElementById("menu");
        menu.style.display = "none";
        this.mobileMenuDisplayed = false
      },
      showPWAInstall() {
        const PWAInstall = document.getElementsByTagName('pwa-install')[0]
        PWAInstall.showDialog()
      }
    }
  }
</script>

<style scoped>

</style>
